import { createSelector } from 'reselect';

const selectMessage = (state) => state.messageTemplate;

export const selectMessageTemplates = createSelector(
  [selectMessage],
  (messageTemplate) => messageTemplate.templates
);
